import createCookie from "./createCookie";

/* eslint-disable */
export default function newGuid() {
  let guid = "XXXXXXXX-XXXX-XXXX-XXXX-";
  guid += new Date().getTime().toString().substr(1);
  createCookie("guid", guid, 365);

  return guid;
}
